// types
export const PRODUCTION_TYPE = 'production'
export const HEALTH_TYPE = 'health'
export const FEED_TYPE = 'feed'
export const ENVIRONMENT_TYPE = 'environment'

// default filters
export const PRODUCTION_COUNT_FILTER = '0' // count | weight | biomass
export const PRODUCTION_WEIGHT_FILTER = '1' // count | weight | biomass
export const PRODUCTION_BIOMASS_FILTER = '2' // count | weight | biomass
export const HEALTH_MORTALITY_FILTER = '0' // mortality | accumulated_mortality
export const HEALTH_ACCUMULATED_MORTALITY_FILTER = '1' // mortality | accumulated_mortality
export const ENVIRONMENT_OXYGEN_FILTER = '0' // oxygen | temperature
export const ENVIRONMENT_TEMPERATURE_FILTER = '1' // oxygen | temperature

export const DATA_SITE_PRODUCTION_STORE_FIELD = 'dataSiteProduction'
export const DATA_SITE_HEALTH_STORE_FIELD = 'dataSiteHealth'
export const DATA_SITE_FEED_STORE_FIELD = 'dataSiteFeed'
export const DATA_SITE_ENVIRONMENT_STORE_FIELD = 'dataSiteEnvironment'
export const DATA_LOCUS_PRODUCTION_STORE_FIELD = 'dataLocusProduction'
export const DATA_LOCUS_HEALTH_STORE_FIELD = 'dataLocusHealth'
export const DATA_LOCUS_FEED_STORE_FIELD = 'dataLocusFeed'
export const DATA_LOCUS_ENVIRONMENT_STORE_FIELD = 'dataLocusEnvironment'
